import { HTMLChakraProps, Text, ThemingProps } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import React, { ElementType } from 'react';

type TextWeight = 'bold' | 'normal' | 'thin';

const DEFAULT_FONTS: Record<TextWeight, string> = {
  bold: FontFamily.HELVETICA_NOW_BOLD,
  normal: FontFamily.HELVETICA_NOW_REGULAR,
  thin: FontFamily.HELVETICA_NOW_THIN,
};

export interface TextBlockProps extends HTMLChakraProps<'p'>, ThemingProps<'Text'> {
  weight?: 'bold' | 'normal' | 'thin';
  fontFamily?: string;
  color?: string;
  as?: ElementType;
}

export const TextBlock: React.FC<TextBlockProps> = (props) => {
  const { weight = 'normal', fontSize = '16px', color = 'black' } = props;

  const fontFamily = props.fontFamily || DEFAULT_FONTS[weight];

  return <Text {...props} fontSize={fontSize} color={color} fontFamily={`${fontFamily}`}></Text>;
};
